//NEW: UI_REVAMP
import { create } from 'zustand';

export const useBottomSheetStore = create((set) => ({
	activeSheet: null,

	openBottomSheet: (id) => set({ activeSheet: id }),
	closeBottomSheet: () => set({ activeSheet: null }),
	toggleBottomSheet: (id) =>
		set((state) => ({
			activeSheet: state.activeSheet === id ? null : id,
		})),
	isAnyOpen: (state) => state.activeSheet !== null,
}));
